
// SVG Icon: map
export default { id: "terriajs-map" };
export const id = "terriajs-map";
export const name = "map";
